export enum SDPReadingConsentEnum {
  YES = 'YES',
  NO = 'NO',
  EMPTY = 'EMPTY',
}
